import { components, DropdownIndicatorProps } from 'react-select';
import { OptionType } from './type';

export const DropdownIndicator = (props: DropdownIndicatorProps<OptionType>) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.currentTarget.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
    }
  };

  return (
    <components.DropdownIndicator
      {...props}
      innerProps={{
        ...props.innerProps,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
      }}
    >
      {props.children}
    </components.DropdownIndicator>
  );
};
